module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create_segment_desc_1":"Select your source of customers","create_segment_desc_2":"Choose one and click \u0027Confirm\u0027"},"id":{"create_segment_desc_1":"Pilih sumber pelanggan Anda","create_segment_desc_2":"Pilih salah satu dan klik \u0027Konfirmasi\u0027"}}')
  delete Component.options._Ctor
}
